class OTP extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const otsInputs = document.querySelectorAll('.otp__form-input-number');

    otsInputs.forEach((input, index) => {
      input.addEventListener('input', (e) => {
        input.value = input.value.replace(/[^0-9]/g, '');

        if (e.target.value.length === 1 && index < otsInputs.length - 1) {
          otsInputs[index + 1].focus();
        }
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace' && e.target.value.length === 0 && index > 0) {
          otsInputs[index - 1].focus();
        }
      });
    });
  }
}

customElements.define('otp-form', OTP);